/* eslint-disable @angular-eslint/directive-selector */
import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  HostListener,
  Input,
} from '@angular/core';

@Directive({ selector: '[clickOutside]' })
export class ClickOutsideDirective {
  @Input() includeHTMLElements: HTMLElement[] = [];

  @Output() clickOutside = new EventEmitter<void>();

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(target: EventTarget | null): void {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    const clickedInsideFromIncludeViews = this.includeHTMLElements.some(
      (element) => element.contains(target as Node),
    );

    if (!clickedInside && !clickedInsideFromIncludeViews) {
      this.clickOutside.emit();
    }
  }
}
